<template>
  <a-modal :title="form.id ? '修改门店预约信息' : '新增门店预约信息'" :visible="visible" :confirm-loading="confirmLoading"
    @ok="handleOk" @cancel="handleCancel" destroyOnClose :maskClosable="false" width="600px">
    <a-form-model ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-form-model-item label="搜索客户" prop="customer_id">
        <a-select v-model="form.customer_id" show-search placeholder="请选择客户" style="width: 100%" :filter-option="false"
          :loading="customerLoading" @search="handleCustomerSearch" @change="handleCustomerChange" allowClear>
          <a-select-option v-for="customer in customerList" :key="customer.customer_id" :value="customer.customer_id">
            {{ customer.customer_name }} {{ customer.customer_phone }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="预约时间" prop="visit_time">
        <a-date-picker v-model="form.visit_time" show-time format="YYYY-MM-DD HH:mm:ss"
          value-format="YYYY-MM-DD HH:mm:00" placeholder="请选择预约时间" style="width: 100%" :disabled-date="disabledDate"
          :show-time="{ format: 'HH:mm' }" />
      </a-form-model-item>
      <a-form-model-item label="人数" prop="num">
        <a-input-number v-model="form.num" :min="1" :max="100" :precision="0" placeholder="请输入人数" style="width: 100%" />
      </a-form-model-item>
      <a-form-model-item label="关系" prop="relationship">
        <a-input v-model="form.relationship" placeholder="请输入关系" />
      </a-form-model-item>
      <a-form-model-item label="订台费" prop="reservation">
        <a-select v-model="form.reservation" placeholder="请选择订台费状态" style="width: 100%">
          <a-select-option value="1">已收</a-select-option>
          <a-select-option value="2">未收</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="状态" prop="status">
        <a-radio-group v-model="form.status">
          <a-radio value="1">已预约</a-radio>
          <a-radio value="2">已到店</a-radio>
          <a-radio value="3">已取消</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="特殊备注" prop="remark">
        <a-textarea v-model="form.remark" placeholder="请输入备注" :rows="3" />
      </a-form-model-item>
      <a-form-model-item label="发送短信" prop="send">
        <a-radio-group v-model="form.send">
          <a-radio value="1">发送短信</a-radio>
          <a-radio value="2">不发送短信</a-radio>
        </a-radio-group>
        <div class="form-tip">
          <a-icon type="info-circle" />
          <span>保存后是否立即发送短信，内容为当前表单内容！</span>
        </div>
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      confirmLoading: false,
      form: {
        customer_id: undefined,
        num: 1,
        relationship: "",
        visit_time: "",
        reservation: "1", // 订台费状态：1已收 2未收
        status: "1", // 预约状态：1已预约 2已到店 3已取消
        send: "1", // 发送短信：1发送短信 2不发送短信
        remark: "",
      },
      customerList: [],
      customerLoading: false,
      customerSearchTimer: null,
      rules: {
        customer_id: [
          {
            required: true,
            message: "请选择客户",
            trigger: "change",
          },
        ],
        num: [
          {
            required: true,
            message: "请输入人数",
            trigger: "blur",
          },
        ],
        relationship: [
          {
            required: false,
            message: "请输入人物关系",
            trigger: "blur",
          },
        ],
        visit_time: [
          {
            required: true,
            message: "请选择预约时间",
            trigger: "change",
          },
        ],
        reservation: [
          {
            required: false,
            message: "请选择订台费状态",
            trigger: "change",
          },
        ],
        status: [
          {
            required: true,
            message: "请选择预约状态",
            trigger: "change",
          },
        ],
        remark: [
          {
            max: 30,
            message: "备注长度不能超过30个字符",
            trigger: "change",
          },
          {
            validator: this.validateRemark,
            trigger: "change",
          },
        ],
      },
      labelCol: { span: 6 },
      wrapperCol: { span: 16 },
    };
  },
  methods: {
    // 禁用今天之前的日期
    disabledDate(current) {
      // 禁用今天之前的日期
      const today = new Date();
      today.setHours(0, 0, 0, 0); // 设置为今天的开始时间
      return current && current < today;
    },
    // 备注字段校验
    validateRemark(rule, value, callback) {
      if (!value || value.trim() === '') {
        callback();
        return;
      }

      // 检查是否包含英文字母
      if (/[a-zA-Z]/.test(value)) {
        callback(new Error('备注不支持英文字母'));
        return;
      }

      // 检查是否只包含简体中文、数字和常用字符
      // 简体中文：\u4e00-\u9fff
      // 数字：0-9
      // 常用字符：标点符号、空格等键盘常见字符
      const allowedPattern = /^[\u4e00-\u9fff0-9\s\.,;:!?()（）【】\[\]""''""''、。，；：！？\-_+=@#$%^&*|\\\/~`<>{}]+$/;

      if (!allowedPattern.test(value)) {
        callback(new Error('备注仅支持简体中文、数字以及常用字符'));
        return;
      }

      callback();
    },
    // 客户搜索
    handleCustomerSearch(value) {
      if (this.customerSearchTimer) {
        clearTimeout(this.customerSearchTimer);
      }
      this.customerSearchTimer = setTimeout(() => {
        if (value && value.trim()) {
          this.searchCustomers(value.trim());
        } else {
          this.customerList = [];
        }
      }, 300);
    },
    // 搜索客户
    searchCustomers(customerName) {
      this.customerLoading = true;
      this.$http({
        url: "/admin/customer/page",
        method: "get",
        params: {
          customer_name: customerName,
          page: 1,
          limit: 20 // 限制返回数量
        }
      }).then((res) => {
        this.customerLoading = false;
        if (res.code === 1) {
          this.customerList = res.data.result || [];
        } else {
          this.customerList = [];
          this.$message.error(res.msg || '搜索客户失败');
        }
      }).catch(() => {
        this.customerLoading = false;
        this.customerList = [];
      });
    },
    // 客户选择变化
    handleCustomerChange(value) {
      this.form.customer_id = value;
    },
    init(id) {
      this.visible = true;
      this.form.id = id;
      if (id) {
        // 编辑模式：获取预约信息
        this.$http({
          url: "/admin/storereservation/info",
          method: "post",
          data: {
            id: id,
          },
        }).then((res) => {
          if (res.code === 1) {
            this.form.customer_id = res.data.customer_id;
            this.form.num = res.data.num;
            this.form.relationship = res.data.relationship;
            this.form.visit_time = res.data.visit_time;
            this.form.reservation = res.data.reservation;
            this.form.status = res.data.status || "1";
            this.form.send = res.data.send || "1";
            this.form.remark = res.data.remark;

            // 如果有客户信息，加载到客户列表中
            if (res.data.customer && res.data.customer.customer_name) {
              this.customerList = [{
                customer_id: res.data.customer_id,
                customer_name: res.data.customer.customer_name
              }];
            }
          } else {
            this.$message.error(res.msg || '获取预约信息失败');
            this.handleCancel();
          }
        }).catch((error) => {
          console.error('获取预约信息失败:', error);
          this.$message.error('获取预约信息失败');
          this.handleCancel();
        });
      } else {
        // 新增时重置表单
        this.form = {
          customer_id: undefined,
          num: 1,
          relationship: "",
          visit_time: "",
          reservation: "1",
          status: "1",
          send: "1",
          remark: "",
        };
        this.customerList = [];
      }
    },
    handleOk() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.confirmLoading = true;
          const form = {
            ...this.form,
          };
          this.$http({
            url: this.form.id ? "/admin/storereservation/update" : "/admin/storereservation/create",
            method: "post",
            data: form,
          })
            .then((res) => {
              this.confirmLoading = false;
              if (res.code === 1) {
                this.$message.success(this.form.id ? "修改成功" : "创建成功");
                this.handleCancel();
                this.$emit("ok");
              } else {
                this.$message.error(res.msg || (this.form.id ? "修改失败" : "创建失败"));
              }
            })
            .catch((error) => {
              this.confirmLoading = false;
              console.error('保存失败:', error);
              this.$message.error(this.form.id ? "修改失败" : "创建失败");
            });
        } else {
          console.log("表单验证失败");
          return false;
        }
      });
    },
    handleCancel() {
      this.visible = false;
      this.confirmLoading = false;
      this.customerList = [];
      this.customerLoading = false;
      if (this.customerSearchTimer) {
        clearTimeout(this.customerSearchTimer);
        this.customerSearchTimer = null;
      }
      this.$refs["ruleForm"].resetFields();
    },
  },
};
</script>

<style scoped>
.form-tip {
  margin-top: 8px;
  padding: 0px 12px;
  background-color: #f6f8fa;
  border: 1px solid #e1e8ed;
  border-radius: 4px;
  font-size: 12px;
  color: #586069;
  display: flex;
  align-items: center;
  gap: 6px;
}

.form-tip .anticon {
  color: #1890ff;
}
</style>
